import HomePage from './homepage'

export default [
  {
    Component: HomePage,
    exact: true,
    path: '/'
  }
]
